import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export interface IRegistrationPreCheckAlert {
  showAlert: boolean;
  showPending: boolean;
  showRefresh: boolean;
  preRegistrationCheckMessage: string;
}

export type RegistrationPreCheckAlertModel = ITypedModel<IRegistrationPreCheckAlert>;

angular.module('capability-ng-scheduler').factory('ngRegistrationPreCheckAlertModel', () => {
  return new Model<IRegistrationPreCheckAlert>({
    showAlert: false,
    showPending: false,
    showRefresh: false,
    preRegistrationCheckMessage: ''
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/components/registration_pre_check/models/registration_pre_check_alert_model.ts